export interface SelectOption {
  value: string;
  label: string;
}

export interface PagedContent {
  pageNumber: number;
  pageSize: number;
  numberOfElements: number;
  totalElements: number;
  totalPages: number;
  first: boolean;
  last: boolean;
  empty: boolean;
}

export const getDefaultPagedContent = (): PagedContent => {
  return {
    pageNumber: 0,
    pageSize: 0,
    numberOfElements: 0,
    totalElements: 0,
    totalPages: 0,
    first: true,
    last: true,
    empty: true,
  };
};

export enum ResultsStatus {
  pendingSearch = 'pendingSearch',
  searching = 'searching',
  noResults = 'noResults',
  results = 'results',
  excessiveResults = 'excessiveResults',
  unmanageableResults = 'unmanageableResults',
  error = 'error',
}

export interface WithContent<T> {
  content: T[];
}

export interface Result<T> {
  resultStatus: ResultsStatus;
  result: T;
}

export interface ColoredSelectOption extends SelectOption {
  color: string;
}
